export default function CdgUniqGroupFilter() {
    return function (elements, index, groupe) {
        if (elements[index][groupe] == '') {
            return;
        }
        return elementss[index];
    };
}
